import { Button, Grid, InputAdornment, TextField } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Category from '../services/db/category';
import AddService from './elements/AddService';
import htmlToPdf from '../utils/htmlToPdf';
import objToXlsx from '../utils/objToXlsx';
import { InfoContext } from '../services/Context/Info/context';
import search from '../utils/searchEngine';
import { Search } from '@mui/icons-material';

const columns = [
    {
        headerName: "Images", field: 'photo', width: 150, renderCell: (params) => (
            <div
                id={params.row.photo}
                style={{
                    backgroundImage: `url("${params.row.photo}")`,
                    backgroundSize: 'cover',
                    width: '52px',
                    height: '52px',
                    margin: 'auto'
                }}
            />)
    },
    { headerName: "Category", field: 'category', width: 200 },
    { headerName: "Subcategory", field: 'subcategory', width: 300 },
    { headerName: "Action", renderCell: (params) => (<AddService data={params.row} />) }
]
function Services() {
    const pdfRef = useRef(null)
    const [searchQuery, setsearchQuery] = useState();
    const { data: { categoryData }, setData } = useContext(InfoContext);
    useEffect(() => {
        if (!categoryData.length) new Category().allCategories().then(r => {
            setData(p => ({ ...p, categoryData: r }))
        })
    }, []);

    const getRowSpacing = React.useCallback((params) => {
        return {
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
        };
    }, []);
    const commonButtonProps = { variant: 'contained', size: 'medium', color: 'primary', fullWidth: true }
    const searchData = search(searchQuery, categoryData, ['category'])
    return (
        <Grid container padding={5} >
            <Grid container item xs={12} spacing={2}>
                <Grid item xs={8} container spacing={2}>
                    <Grid item xs={4}>
                        <Button
                            {...commonButtonProps}
                            onClick={() => objToXlsx(categoryData, 'service')}
                        >
                            Excel
                        </Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button
                            {...commonButtonProps}
                            onClick={() => htmlToPdf(pdfRef.current, 'service', "save")}
                        >
                            PDF
                        </Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button
                            {...commonButtonProps}
                            onClick={() => htmlToPdf(pdfRef.current, 'service', "view")}
                        >
                            Print
                        </Button>
                    </Grid>
                </Grid>
                <Grid item xs={4} container padding={2}>
                    <TextField
                        fullWidth
                        size='small'
                        InputProps={{
                            startAdornment: <InputAdornment><Search /></InputAdornment>
                        }}
                        onChange={e => setsearchQuery(e.currentTarget.value)}
                    />
                </Grid>
                <Grid item xs={8}></Grid>
                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end' }} marginBottom={2} padding={2}>
                    <AddService />
                </Grid>
            </Grid>
            <Grid container item xs={12} spacing={2}>
                <DataGrid
                    ref={pdfRef}
                    rows={searchData}
                    columns={columns}
                    style={{ backgroundColor: '#FAF0E6' }}
                    hideFooter={true}
                    getRowSpacing={getRowSpacing}
                />
            </Grid>
        </Grid>
    )
}

export default Services